export default {
  metrics: {
    go_lives: 'Total de Go Lives',
    avg_quality_score: 'Pontuação Média de Qualidade',
    managers: {
      title: 'Gestores de Onboarding',
      fields: {
        name: 'Nome do Gestor',
        go_lives: 'Go Lives',
        avg_quality_score: 'Pont. Média de Qualidade',
      },
    },
  },
  details: {
    name: 'Restaurante',
    owner: 'Nome do proprietário',
    owner_phone: 'Telefone do proprietário',
    owner_email: 'Email do proprietário',
    live_from: 'Data de lançamento',
    onboarding_manager: 'Gestor de Onboarding',
    sales_manager: 'Gestor de Vendas',
    onboarding_quality_score: 'Pontuação de Qualidade',
    export_csv: 'Exportar CSV',
  },
};
